import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteSpotAvatarsService = async (spotId: string): Promise<void> => {
  await jhsfBookingsApi.delete(`/avatars/spots/${spotId}`);
};

export default deleteSpotAvatarsService;
